import React from "react";
import {Link} from 'react-router-dom'
import * as ROUTES from '../../constants/routes'

const Landing = () =>(
    <div>

    </div>

);


export default Landing